export const DIALOG_CLOSE_EVENTS = ['BACKDROP_CLICK', 'CLOSE_BUTTON', 'ESCAPE_KEY_DOWN'];
